<template lang="pug">
  include ./../../mixins
  component(
    :is="component"
    :object-item="this.objectItem"
    @close="$emit('close')"
  )
</template>

<script>
export default {
  name: 'SampleModal',
  props: {
    component: {
      required: false,
    },
    objectItem: {
      required: false,
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Modals/SampleModal.vue